module.exports = __webpack_public_path__ + "static/media/Desktop.6ff7e5b1.png";